module.exports = __webpack_public_path__ + "assets/img/A4-1.3d146e81.jpg";